import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import SplashScreen from '@/components/layout/SplashScreen'
import QrCode from './views/QrCode.vue'
import GeolocLeatlet from './components/Geoloc/GeolocLeaflet.vue'

import Auth from '@/middlewares/auth'

// Prevent to display an error on Navigation Duplicated event.
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    // Reset to top of the screen on route change
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: Auth,
      component: Home /*Layout_login.vue (without sidenav)*/
      // component: () =>
      //   import(
      //     /* webpackChunkName: "components" */ './views/Homes/Homes.vue'
      //   )
    },
    {
      path: '/addresses',
      name: 'addresses',
      component: () =>
        import(
          /* webpackChunkName: "components" */ './components/userAccount/personnalInformation/Addresses.vue'
        )
    },
    {
      path: '/splashScreen',
      name: 'splashScreen',
      component: SplashScreen /*Layout.vue (with sidenav)*/
    },
    {
      path: '/transition/:name',
      name: 'transition',
      component: () => import(/* webpackChunkName: "components" */ './views/Transition.vue')
    },
    {
      path: '/scan',
      name: 'qrcode',
      beforeEnter: Auth,
      component: QrCode
    },
    {
      path: '/locate/:themeId',
      name: 'geoloc',
      beforeEnter: Auth,
      component: GeolocLeatlet
    },
    /**
     * ------ MASTERCLASS ------
     */
    {
      path: '/theme',
      name: 'themeList',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/ThemeList.vue'),
      meta: {
        breadcrumb: ['home', 'userAccountHome']
      }
    },
    {
      path: '/theme/:themeId(\\w+)',
      name: 'theme',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/Theme.vue'),
      meta: {
        breadcrumb: ['home', 'userAccountHome', 'themeList']
      }
    },
    {
      path: '/theme/:themeId/lessonStep/:lessonStepId',
      name: 'lessonStep',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/LessonStep.vue')
    },
    {
      path: '/theme/:themeId/lessonStep/:lessonStepId/lesson/:lessonId',
      name: 'lesson',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "lesson" */ './views/masterclass/Lesson.vue')
    },
    /**
     * ------ QUIZ ------
     */
    {
      path: '/quiz',
      name: 'quizList',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizList.vue')
    },
    {
      path: '/quiz/:contentType/:contentId',
      name: 'quiz',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/Quiz.vue')
    },
    {
      path: '/quiz/:contentType/:contentId/question/:questionId',
      name: 'quizQuestion',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizStep.vue')
    },
    {
      path: '/quiz/:contentType/:contentId/result',
      name: 'quizResult',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizResult.vue')
    },
    {
      path: '/quiz/:contentType/:contentId/wrong-responses',
      name: 'quizWrongResponses',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "quiz" */ './views/quiz/QuizWrongResponses.vue')
    },
    /**
     * ------ AUTH ------
     */
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/vinoways/Login.vue')
    },
    {
      path: '/preregister',
      name: 'preregister',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/auth/vinoways/PreRegister.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/vinoways/Register.vue')
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/auth/vinoways/ResetPassword.vue')
    },
    {
      path: '/confirm-reset-password',
      name: 'confirmResetPassword',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/auth/vinoways/ConfirmResetPassword.vue')
    },
    {
      path: '/validate-account',
      name: 'validation-account',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/auth/vinoways/ValidateAccount.vue')
    },
    {
      path: '/confirm-registration',
      name: 'confirm-registration',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/auth/vinoways/ConfirmRegistration.vue')
    },
    /**
     * ------ USER ACCOUNT ------
     */
    {
      path: '/userAccount',
      name: 'userAccount',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "user" */ './views/userAccount/UserAccount.vue'),
      children: [
        {
          path: '',
          name: 'userAccountHome',
          component: () => import(/* webpackChunkName: "user" */ './views/userAccount/Home.vue')
        },
        {
          path: 'language',
          name: 'userAccountLanguage',
          component: () => import(/* webpackChunkName: "user" */ './views/userAccount/Language.vue')
        },
        {
          path: 'personnalInformation',
          name: 'userAccountPersonnalInformation',
          component: () =>
            import(/* webpackChunkName: "user" */ './views/userAccount/PersonnalInformation.vue')
        },
        {
          path: 'favoriteWine',
          name: 'userAccountFavoriteWine',
          component: () =>
            import(/* webpackChunkName: "user" */ './views/userAccount/FavoriteWines.vue')
        },
        {
          path: 'progression',
          name: 'userProgression',
          component: () =>
            import(/* webpackChunkName: "user" */ './views/userAccount/UserProgression.vue')
        },
        {
          path: 'progression/:themeId',
          name: 'userProgressionDetail',
          component: () =>
            import(/* webpackChunkName: "user" */ './views/userAccount/UserProgressionDetail.vue')
        }
      ]
    },
    /**
     * ------ TASTINGS ------
     */
    {
      path: '/listTasting',
      name: 'listTasting',
      beforeEnter: Auth,
      component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/TastingList.vue')
    },
    {
      path: '/tasting/:tastingId/',
      name: 'tasting-question',
      beforeEnter: Auth,
      component: () =>
        import(/* webpackChunkName: "tasting" */ './views/tasting/TastingListQuestion.vue')
    },
    {
      path: '/tasting/:tastingId/rating',
      name: 'tasting-rating',
      component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Rating.vue')
    },
    // {
    //   path: '/tasting',
    //   name: 'tasting-skeleton',
    //   beforeEnter: Auth,
    //   component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Skeleton.vue'),
    //   children: [
    //     {
    //       path: ':tastingId',
    //       name: 'tasting-funnel',
    //       component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Tasting.vue')
    //     },
    //     {
    //       path: ':tastingId/section/:sectionId',
    //       name: 'tasting-section',
    //       component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Section.vue'),
    //       children: [
    //         {
    //           path: 'step/:stepId',
    //           name: 'tasting-step',
    //           component: () => import(/* webpackChunkName: "tasting" */ './views/tasting/Step.vue')
    //         },
    //         {
    //           path: 'summary',
    //           name: 'section-summary',
    //           component: () =>
    //             import(/* webpackChunkName: "tasting" */ './views/tasting/Summary.vue')
    //         }
    //       ]
    //     },
    //   ]
    // }
  ]
})
